"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var utilities_1 = require("../../utilities");
var __1 = require("../");
var Tag = function (_a) {
    var badge = _a.badge, children = _a.children, className = _a.className, _b = _a.color, color = _b === void 0 ? 'default' : _b, compact = _a.compact, iconName = _a.icon, onClose = _a.onClose, subtle = _a.subtle, title = _a.title, tagRef = _a.tagRef, props = __rest(_a, ["badge", "children", "className", "color", "compact", "icon", "onClose", "subtle", "title", "tagRef"]);
    var isCustomColor = function () {
        var uniqueColors = [
            'info',
            'warning',
            'critical',
            'success',
            'inactive',
            'default',
            'inverse',
        ];
        if (!uniqueColors.includes(color))
            return true;
        return false;
    };
    var getColorClasses = function () {
        if (isCustomColor())
            return utilities_1.isDark(color) ? 'Tag--lightText' : 'Tag--darkText';
        if (!isCustomColor())
            return "Tag--" + color;
    };
    var TagClasses = classnames_1.default('Tag', className, getColorClasses(), {
        'Tag--compact': compact,
        'Tag--subtle': subtle,
        'Tag--badge': badge,
    });
    var getTextFromChildren = function (children) {
        return react_1.default.Children.toArray(children)
            .reduce(function (flattened, child) {
            var _a;
            return __spreadArray(__spreadArray([], flattened), [
                ((_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.children)
                    ? getTextFromChildren(child.props.children)
                    : child,
            ]);
        }, [])
            .filter(function (str) { return !str.toString().includes('object Object'); })
            .join('');
    };
    var actualTitle = title !== undefined ? title : "Tag: " + getTextFromChildren(children);
    return (react_1.default.createElement("div", __assign({ className: TagClasses, title: actualTitle, style: isCustomColor() ? { backgroundColor: color } : null, ref: tagRef }, props),
        iconName ? (react_1.default.createElement("span", { className: "Tag__icon" },
            react_1.default.createElement(__1.Icon, { name: iconName, size: compact ? 14 : 16 }))) : null,
        react_1.default.createElement("span", { className: "Tag__body" }, children),
        onClose && (react_1.default.createElement(__1.Button, { fill: "subtle", className: "Tag__close", iconName: "clear", size: "xsmall", onClick: onClose }))));
};
exports.Tag = Tag;
//# sourceMappingURL=Tag.js.map